import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/style.css'
import './assets/css/animations.css'
import {getRequest} from "@/api/api";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css'
import svgIcon from '@/components/common/svg-icon'
Vue.prototype.getRequest = getRequest;
Vue.component('svgIcon', svgIcon)
Vue.config.productionTip = false
Vue.use(Antd)

// Scroll-reveal directive: adds `is-visible` when element enters viewport.
// On parent with data-animate-stagger: staggers children's is-visible.
Vue.directive('animate-on-scroll', {
  inserted(el) {
    const isStagger = el.hasAttribute('data-animate-stagger')
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          if (isStagger) {
            const children = Array.from(el.querySelectorAll('[data-animate]'))
            children.forEach((child, i) => {
              setTimeout(() => child.classList.add('is-visible'), i * 130)
            })
          } else {
            el.classList.add('is-visible')
          }
          observer.unobserve(el)
        })
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    )
    observer.observe(el)
  }
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
